import type { ButtonHTMLAttributes } from 'react'

type PrimaryButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  fullWidthOnMobile?: boolean
}

// Locked CTA (ux_decisions 2026-05-25): sentence-case label supplied by caller,
// solid navy, 48px tall, white label, sharp corners, no shadow. Full-width on
// mobile, auto-width on desktop.
export default function PrimaryButton({
  className = '',
  fullWidthOnMobile = true,
  children,
  type = 'button',
  ...rest
}: PrimaryButtonProps) {
  return (
    <button
      type={type}
      {...rest}
      className={[
        'inline-flex h-12 items-center justify-center px-8',
        'bg-ob-ink font-body text-base font-semibold text-ob-on-ink',
        'rounded-none transition-colors hover:bg-ob-ink/90',
        'disabled:cursor-not-allowed disabled:opacity-50',
        'focus:outline-none focus-visible:ring-2 focus-visible:ring-ob-ink focus-visible:ring-offset-2 focus-visible:ring-offset-ob-surface',
        fullWidthOnMobile ? 'w-full sm:w-auto' : '',
        className,
      ].join(' ')}
    >
      {children}
    </button>
  )
}
